/* eslint @typescript-eslint/strict-boolean-expressions: off */

import Link from "next/link";
import { Cell } from "gui/grid/cell";
import { Empty } from "gui/empty/empty";
import { Grid } from "gui/grid/grid";
import { Icon } from "gui/icon/icon";
import { Subtitle } from "gui/subtitle/subtitle";
import { entryIcon } from "lib/entries/entries";
import { EntrySlug } from "lib/entries/types";
import { StaticTeamProfileData } from "../fetchStaticTeamProfileData";
import { ReactNode } from "react";

interface Props {
  team: StaticTeamProfileData;
  list: ReactNode | false;
  title: string;
  slug: EntrySlug;
}

export default function TeamEntries(props: Props) {
  const id = `aria-${props.team.handle}-${props.slug}`;
  const href = "/browse/[slug]";
  const as = `/browse/${props.slug}?team=${props.team.handle}`;
  const icon = entryIcon(props.slug);
  const hasItems = Boolean(props.list);

  return (
    <Grid aria-labelledby={id} gaps>
      <Subtitle id={id} icon={icon} text={props.title}>
        {hasItems && (
          <Link href={href} as={as} prefetch={false}>
            <a>
              All {props.slug}
              <Icon icon="arrow-right" />
            </a>
          </Link>
        )}
      </Subtitle>
      <Cell>{props.list || <TeamEntriesEmpty slug={props.slug} />}</Cell>
    </Grid>
  );
}

const TeamEntriesEmpty: React.FC<{
  slug: string;
}> = (props) => {
  return (
    <Empty icon="circle-fill">
      <p>No {props.slug} yet.</p>
    </Empty>
  );
};
